import {connect} from 'react-redux';

import {WorkspaceDisplaySectionTrackingTypesEnum} from '../../../../../libs/shared/core/src/models/tracking/contexts/workspaceTracking';
import {
  InterfaceEventsEnum,
  trackInterfaceEvent,
} from '../../../../../libs/shared/core/src/services/tracking/tracking';
import {makeMapDispatchToProps, makeMapStateToProps} from '../../../../../srcCommon/helpers/reselectHelpers';
import {LensModel} from '../../../../models/api/lensModel';
import {RefinementOptionModel} from '../../../../models/api/refinementOptionModel';
import {AppState} from '../../../../store/appState';
import {WorkspaceDropReorderLensHandler} from '../../../../store/data/workspace/reorder/types';
import {reorderLensInLensesWorkspaceAsyncAction} from '../../../../store/data/workspace/workspaceActions';
import {LensesWorkspaceItemContainerBase} from './lensesWorkspaceItemContainerBase';

/*
 * Props.
 */

interface LensWorkspaceItemContainerProps {
  lens: LensModel;
  selectedRefinement: RefinementOptionModel | undefined;
}

/*
 * Selectors.
 */

function getShouldShowRefinedResultsIndicator(_state: AppState, props: LensWorkspaceItemContainerProps) {
  return props.selectedRefinement !== undefined;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<LensWorkspaceItemContainerProps>()(() => ({
  shouldShowRefinedResultsIndicator: getShouldShowRefinedResultsIndicator,
}));

const mapDispatchToProps = makeMapDispatchToProps()(() => ({
  reorderLensInLensesWorkspace: reorderLensInLensesWorkspaceAsyncAction,
}));

/** For use in displaying a lens in the lenses workspace. Not to be used when editing the workspace. */
export const LensesWorkspaceItemContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  (stateProps, dispatchProps, ownProps) => {
    const onDropReorderLens: WorkspaceDropReorderLensHandler = (dropArgs) => {
      trackInterfaceEvent(InterfaceEventsEnum.P1_WORKSPACE_REORDER, {
        section: WorkspaceDisplaySectionTrackingTypesEnum.LENS,
      });
      dispatchProps.reorderLensInLensesWorkspace(dropArgs);
    };
    return {
      ...stateProps,
      ...ownProps,
      shouldHideMoreMenu: false,
      isEditingWorkspace: false,
      onDropReorderLens,
    };
  },
)(LensesWorkspaceItemContainerBase);
